module.exports = __webpack_public_path__ + "img/weal_content_2.9db89efd.png";